import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const BottomActionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%', 
  margin: '10px 0px',
})